import { render, staticRenderFns } from "./S.Pattern.vue?vue&type=template&id=0cf37951&"
import script from "./S.Pattern.vue?vue&type=script&lang=js&"
export * from "./S.Pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports